import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { loginUser, registerUser } from '../services/api';
import { useAuth } from '../context/AuthContext';
//import './Login.css';

const Login = () => {
  const [isLogin, setIsLogin] = useState(true);
  const [formData, setFormData] = useState({
    email: '',
    password: '',
    confirmPassword: ''
  });
  const [error, setError] = useState('');
  const navigate = useNavigate();
  const { login } = useAuth();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    try {
      if (isLogin) {
        // Connexion
        const response = await loginUser(formData.email, formData.password);
        if (response.success) {
          login(response.token, response.user);
          navigate('/');
        } else {
          setError(response.message);
        }
      } else {
        // Inscription
        const response = await registerUser(formData.email, formData.password);
        if (response.message === 'User created or password updated successfully') {
          // Optionnel : Connecter l'utilisateur immédiatement après l'inscription
          const loginResponse = await loginUser(formData.email, formData.password);
          if (loginResponse.success) {
            login(loginResponse.token, loginResponse.user);
            navigate('/');
          }
        } else {
          setError(response.message);
        }
      }
    } catch (err) {
      console.error('Erreur:', err);
      setError('Une erreur est survenue');
    }
  };

  return (
    <div className="login-container">
      <div className="login-box">
        <h2>{isLogin ? 'Connexion' : 'Inscription'}</h2>
        {error && <div className="alert alert-danger">{error}</div>}
        
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>Email</label>
            <input
              type="email"
              className="form-control"
              value={formData.email}
              onChange={(e) => setFormData({...formData, email: e.target.value})}
              required
            />
          </div>

          <div className="form-group">
            <label>Mot de passe</label>
            <input
              type="password"
              className="form-control"
              value={formData.password}
              onChange={(e) => setFormData({...formData, password: e.target.value})}
              required
            />
          </div>

          {!isLogin && (
            <div className="form-group">
              <label>Confirmer le mot de passe</label>
              <input
                type="password"
                className="form-control"
                value={formData.confirmPassword}
                onChange={(e) => setFormData({...formData, confirmPassword: e.target.value})}
                required
              />
            </div>
          )}

          <button type="submit" className="btn btn-primary w-100">
            {isLogin ? 'Se connecter' : 'S\'inscrire'}
          </button>
        </form>

        <p className="mt-3 text-center">
          {isLogin ? 'Pas de compte ?' : 'Déjà un compte ?'}
          <button
            className="btn btn-link"
            onClick={() => setIsLogin(!isLogin)}
          >
            {isLogin ? 'S\'inscrire' : 'Se connecter'}
          </button>
        </p>
      </div>
    </div>
  );
};

export default Login; 